/**
 * Newsletter subscription form schema
 */

import { z } from 'zod';
import { ITranslationContext } from '../../utils/resources/types';
import { createBaseFieldSchemas } from '../base-fields';

/**
 * Newsletter subscription schema factory with i18n support
 */
export const getNewsletterSubscriptionSchema = (translationContext?: ITranslationContext) => {
    const { emailSchema, optionalCheckboxSchema, requiredCheckboxSchema } = createBaseFieldSchemas(translationContext);

    return z.object({
        email: emailSchema,
        marketingEmails: requiredCheckboxSchema,
        profiling: optionalCheckboxSchema,
        thirdParty: optionalCheckboxSchema
    });
};

// Type inference
export type NewsletterSubscriptionFormData = z.infer<ReturnType<typeof getNewsletterSubscriptionSchema>>;
